import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import "./WorldStart.css";
import TextBubble from "../TextBubble/TextBubble";
import FinnHappy from "../../Assets/Images/Characters/Finn/Finn_happy_light.png";
import { useWorldData } from "../../context/WorldContext";
import { getWorld } from "../../utils/dialogueUtils";
import { getUserProgress, setUserProgress } from "../../utils/userUtils";

function WorldStart() {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedWorldType = location.state?.worldType || "";
  const [description, setDescription] = useState("");
  const [continueProgress, setContinueProgress] = useState(false);
  const [progressDialogue, setProgressDialogue] = useState(false);
  // Use world context
  const {
    currentWorldOrder,
    setCurrentWorldOrder,
    currentWorldId,
    setCurrentWorldId,
  } = useWorldData();

  //Redirect to Map if trying to access directly
  useEffect(() => {
    if (selectedWorldType === "") {
      navigate("/map"); // Redirect to /map
    }
  }, [selectedWorldType, navigate]);

  const fetchWorldDetails = useCallback((currentWorldOrder) => {
    const world = getWorld(currentWorldOrder);
    setCurrentWorldId(world.order);
    setDescription(world.description);
  });

  useEffect(() => {
    switch (selectedWorldType) {
      case "Introduction":
        setCurrentWorldOrder(0);
        fetchWorldDetails(0);
        break;
      case "Key Terms":
        setCurrentWorldOrder(1);
        fetchWorldDetails(1);
        break;
      case "Puberty Health/Gender exploration":
        setCurrentWorldOrder(2);
        fetchWorldDetails(2);
        break;
      case "Social Transition":
        setCurrentWorldOrder(3);
        fetchWorldDetails(3);
        break;
      case "Medical Transition":
        setCurrentWorldOrder(4);
        fetchWorldDetails(4);
        break;
      case "Legal Transition":
        setCurrentWorldOrder(5);
        fetchWorldDetails(5);
        break;
      case "Sex Education":
        setCurrentWorldOrder(6);
        fetchWorldDetails(6);
        break;
      case "STBBI’s":
        setCurrentWorldOrder(7);
        fetchWorldDetails(7);
        break;
      case "Mental Health":
        setCurrentWorldOrder(8);
        fetchWorldDetails(8);
        break;
      case "Community Connections":
        setCurrentWorldOrder(9);
        fetchWorldDetails(9);
        break;
      default:
        setCurrentWorldOrder(0);
        fetchWorldDetails(0);
        break;
    }
  }, [selectedWorldType, fetchWorldDetails]);

  useEffect(() => {
    progressChecker();
  }, [currentWorldId]);

  //Checking the if progress exists
  const progressChecker = useCallback(() => {
    const progress = getUserProgress();
    const worldProgress = progress.worldProgresses.find(
      (world) => world.world == currentWorldId
    );
    if (worldProgress.status === "inProgress") {
      setContinueProgress(true);
      setProgressDialogue(worldProgress.nextDialogue);
    } else {
      setContinueProgress(false);
      setProgressDialogue(null);
    }
  }, [currentWorldId]);

  //Function that redirects to World beginning or continue progress
  const redirectToWorld = (status) => {
    if (status === "begin") {
      setProgressDialogue(null);
      const progress = getUserProgress();
      progress.lastWorld = currentWorldId;
      progress.lastDialogue = null;
      progress.status = "inProgress";
      const worldProgress = progress.worldProgresses.find(
        (world) => world.world == currentWorldId
      );
      worldProgress.status = "inProgress";
      worldProgress.dialogueHistory = [];
      worldProgress.nextDialogue = null;
      setUserProgress(progress);
      navigate("/World", {
        state: { currentWorldOrder: currentWorldOrder, progressDialogue: null },
      });
    } else if (status === "continue") {
      navigate("/World", {
        state: {
          currentWorldOrder: currentWorldOrder,
          progressDialogue: progressDialogue,
        },
      });
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="world-container"
    >
      <h1>Welcome to the World of {selectedWorldType}</h1>
      <div>
        {description && (
          <motion.p
            className="overview"
            initial={{ x: "-100vw" }}
            animate={{ x: 0 }}
            transition={{ type: "fade", duration: 1 }}
          >
            Overview: {description}
          </motion.p>
        )}
      </div>
      <div className="row">
        <div className="col-4">
          <motion.img
            src={FinnHappy}
            alt="Finn Happy"
            initial={{ scale: 0 }}
            animate={{ scale: [1, 1.05, 1] }}
            transition={{
              scale: { repeat: Infinity, duration: 4, ease: "easeInOut" },
            }}
          />
        </div>
        <div className="col-8">
          <TextBubble>
            {"Excellent choice! Ready to dive deeper into " +
              selectedWorldType +
              "?"}
          </TextBubble>
          <Flex
            className="button-container"
            justifyContent="space-around"
            alignItems="center"
          >
            <Button
              colorScheme="teal"
              size="lg"
              onClick={() => redirectToWorld("begin")}
            >
              Begin Adventure
            </Button>
            {continueProgress && (
              <Button
                colorScheme="teal"
                size="lg"
                onClick={() => redirectToWorld("continue")}
              >
                Continue Adventure
              </Button>
            )}
          </Flex>
        </div>
      </div>
    </motion.div>
  );
}

export default WorldStart;
